module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "matrix-cmp"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('form', {
    staticClass: "options muted"
  }, [_c('strong', [_vm._v("Options:")]), _vm._v(" "), _c('span', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shouldRemoveEmptyRow),
      expression: "shouldRemoveEmptyRow"
    }],
    attrs: {
      "type": "checkbox",
      "id": "shouldRemoveEmptyRow"
    },
    domProps: {
      "checked": Array.isArray(_vm.shouldRemoveEmptyRow) ? _vm._i(_vm.shouldRemoveEmptyRow, null) > -1 : (_vm.shouldRemoveEmptyRow)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.shouldRemoveEmptyRow,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.shouldRemoveEmptyRow = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.shouldRemoveEmptyRow = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.shouldRemoveEmptyRow = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "shouldRemoveEmptyRow"
    }
  }, [_vm._v("Remove Empty Row(s)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shouldStartWithRandoms),
      expression: "shouldStartWithRandoms"
    }],
    attrs: {
      "type": "checkbox",
      "id": "shouldStartWithRandoms"
    },
    domProps: {
      "checked": Array.isArray(_vm.shouldStartWithRandoms) ? _vm._i(_vm.shouldStartWithRandoms, null) > -1 : (_vm.shouldStartWithRandoms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.shouldStartWithRandoms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.shouldStartWithRandoms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.shouldStartWithRandoms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.shouldStartWithRandoms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "shouldStartWithRandoms"
    }
  }, [_vm._v("Start with Random Sequence")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "option"
  }, [_vm._v("\n        Max Rows:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rowsN),
      expression: "rowsN",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "rowsN-16",
      "value": "16"
    },
    domProps: {
      "checked": _vm._q(_vm.rowsN, _vm._n("16"))
    },
    on: {
      "__c": function($event) {
        _vm.rowsN = _vm._n("16")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rowsN-16"
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rowsN),
      expression: "rowsN",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "rowsN-32",
      "value": "32"
    },
    domProps: {
      "checked": _vm._q(_vm.rowsN, _vm._n("32"))
    },
    on: {
      "__c": function($event) {
        _vm.rowsN = _vm._n("32")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rowsN-32"
    }
  }, [_vm._v("32")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rowsN),
      expression: "rowsN",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "rowsN-0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.rowsN, _vm._n("0"))
    },
    on: {
      "__c": function($event) {
        _vm.rowsN = _vm._n("0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rowsN-0"
    }
  }, [_vm._v("∞")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onRestart($event)
      }
    }
  }, [_vm._v("Restart")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onNext($event)
      }
    }
  }, [_vm._v("Next round")])]), _vm._v(" "), _c('dl', {
    staticClass: "info muted"
  }, [_c('dt', [_vm._v("Sequence length:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(this.curSequence.length))]), _vm._v(" "), _c('dt', [_vm._v("Rows number:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.matrix.length))]), _vm._v(" "), _c('dt', [_vm._v("Max Size:")]), _vm._v(" "), (_vm.rowsN) ? _c('dd', [_vm._v(_vm._s(_vm.colsN) + "×" + _vm._s(_vm.rowsN))]) : _c('dd', [_vm._v("unlim")])])]), _vm._v(" "), _c('article', {
    staticClass: "matrix"
  }, _vm._l((_vm.matrix), function(m, row) {
    return _c('div', {
      key: row,
      staticClass: "row"
    }, _vm._l((_vm.colsN), function(col) {
      return _c('div', {
        key: col,
        class: ['cell', _vm.clsCell([row, col - 1])],
        on: {
          "click": function($event) {
            _vm.onChoose([row, col - 1])
          }
        }
      }, [(_vm.isCell([row, col - 1])) ? _c('span', {
        staticClass: "symbol digit"
      }, [_vm._v("\n          " + _vm._s(_vm.getCell([row, col - 1])) + "\n        ")]) : (_vm.isCleared([row, col - 1])) ? _c('span', {
        staticClass: "symbol cleared"
      }, [_vm._v("\n          •\n        ")]) : _vm._e()])
    }))
  })), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "guidelines muted"
  }, [_c('dl', [_c('dt', [_vm._v("Goal:")]), _vm._v(" "), _c('dd', [_vm._v("You need to clear up all INFECTED cells")]), _vm._v(" "), _c('dt', [_vm._v("Next Round:")]), _vm._v(" "), _c('dd', [_vm._v("It just DUPLICATES current strain")])]), _vm._v(" "), _c('h3', [_vm._v("You can neutralize TWO infected cells by these RULES:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("They both should be on the same VERTICAL, HORIZONTAL or DIAGONAL,")]), _vm._v(" "), _c('li', [_vm._v("They both should be VISIBLE to each other,")]), _vm._v(" "), _c('li', [_vm._v("They both should have the SAME VALUE or make a SUM OF 10.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e54515e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Matrix.vue
// module id = 86
// module chunks = 1